import { render, staticRenderFns } from "./SplitScreenLayout.vue?vue&type=template&id=bf345436&"
import script from "./SplitScreenLayout.vue?vue&type=script&lang=js&"
export * from "./SplitScreenLayout.vue?vue&type=script&lang=js&"
import style0 from "./SplitScreenLayout.vue?vue&type=style&index=0&id=bf345436&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports